<template>
    <div>
        <b-modal
            id="manual-alert-popup"
            ref="modal"
            title="Create Manual Alert"
            size="sm"
            no-close-on-backdrop
            no-close-on-esc
            :hide-header-close="loading"
            modal-class="hide-footer"
            hide-footer
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            class="kyc-status-radio overwrite-radio"
                            label="Reject Customer"
                            label-for="reject-customer"
                        >
                            <b-form-group>
                                <b-form-radio-group
                                    id="reject-customer"
                                    v-model="formData.rejectCustomer"
                                    :options="rejectCustomerOptions"
                                    name="rejectCustomer"
                                ></b-form-radio-group>
                            </b-form-group>
                        </b-form-group>
                    </div>
                    <div v-if="!formData.rejectCustomer" class="col-md-12">
                        <b-form-group
                            id="input-group-2"
                            label="Override Risk Rating To"
                            label-for="rating"
                        >
                            <b-form-select
                                id="rating"
                                v-model="formData.riskRating"
                                class="form-control"
                                :options="ratingOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-3"
                            label="Reason"
                            label-for="reason"
                        >
                            <b-form-textarea
                                id="reason"
                                v-model="formData.comments"
                                v-validate="{
                                    required: true,
                                }"
                                name="reason"
                                placeholder="Start typing the reason"
                                rows="3"
                                :class="{
                                    'is-invalid': errors.has('reason'),
                                }"
                            ></b-form-textarea>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Submit"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
            rejectCustomerOptions: [
                { text: 'Yes', value: true },
                { text: 'No', value: false },
            ],

            ratingOptions: [
                { value: null, text: 'Select Risk Rating' },
                { value: 'high', text: 'High Risk' },
                { value: 'medium', text: 'Medium Risk' },
                { value: 'low', text: 'Low Risk' },
                { value: 'sanction', text: 'Sanctioned' },
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'hidePopup',
            'dataSegmentId',
            'customerRecord',
        ]),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > watch
    mounted() {
        // this.getCustomerData()
    },

    methods: {
        /**
         * Initialize formData with default values
         *
         * @return {formData}
         */
        initializeFormData() {
            return {
                dataSegmentId: this.dataSegmentId,
                customerId: null,
                comments: '',
                rejectCustomer: true,
                riskRating: null,
            }
        },
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    // initiate review process for this alert
                    this.$store.commit('setLoading', true)

                    let resourceApi = new resource('alerts/')
                    this.formData.dataSegmentId = localStorage.getItem(
                        'activeDataSegmentId'
                    )
                    this.formData.customerId = this.$route.params.id
                    if (this.formData.rejectCustomer) {
                        this.formData.riskRating =
                            this.customerRecord.kycSummary.riskRating
                    }
                    let { data } = await resourceApi.store(this.formData)
                    if (data) {
                        this.$store.commit('setRefreshProfile', true)
                        this.$store.commit('setSuccess', data.message)
                    }
                } catch (error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error)
                    console.log(error, 'There is an error on submit')
                }
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('setLoading', false)

            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
    },
}
</script>
